import { render, staticRenderFns } from "./Historics.vue?vue&type=template&id=5eabd5aa&scoped=true&"
import script from "./Historics.vue?vue&type=script&lang=js&"
export * from "./Historics.vue?vue&type=script&lang=js&"
import style0 from "./Historics.vue?vue&type=style&index=0&id=5eabd5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eabd5aa",
  null
  
)

export default component.exports